import { CommonModule } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SpinnerComponent } from '../../layout/spinner/spinner.component';
import { AdminService } from 'src/app/services/admin/admin.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MenuService } from 'src/app/services/menu/menu.service';

@Component({
  selector: 'app-admins',
  imports: [CommonModule, FormsModule, SpinnerComponent, ReactiveFormsModule],
  templateUrl: './admins.component.html',
  styleUrl: './admins.component.css'
})
export class AdminsComponent {
    load = false
    error = false
    data: any

    @ViewChild('editAdminModal') editAdminModalRef!: TemplateRef<any>;

    btnLoad = false;
    isEditMode = false;
    editBtnLoad = false;

    postsLoad = false
    postsError = false

    form!: FormGroup

    postCategoriesList: any

    deleteUserId = 0

    allMenus: Record<string, any[]> = {};

    loading = false;
    menuOptions: Array<{ id: number; title: string }> = [];
    activeModalRef: any = null;

    menuSearch = '';


    constructor(
      private AdminService: AdminService,
      private modalService: NgbModal,
      private fb: FormBuilder,
      private ToastrService: ToastrService,
      private MenuService: MenuService, 

    ){
      this.getAdmins()
      this.getMenu()

     this.form = this.fb.group({
        id: [null],
        user: [''],
        name: [''],
        lastname: [''],
        password: [''],
        repeatPassword: [''],
        role: ['admin'],

        // UI permissions (checkboxes)
        permissions: this.fb.group({
          menus_view: [false],
          menus_create: [false],
          menus_edit: [false],
          menus_delete: [false],

          pages_view: [false],
          pages_create: [false],
          pages_edit: [false],
          pages_delete: [false],

          posts: [false],
          calendar: [false],
          team: [false],
          banner: [false],
          forms: [false],
          faq: [false],
          gallery: [false],
          files: [false],
          live: [false],
          comments: [false],
          admins: [false],
          settings: [false],
          logs: [false],
          info: [false],
        }),

        // Menu access list (multi-select)
        menu_ids: [[]],

        // keep your existing fields
        postCategories: [[]],
      });

    }


    getAdmins(){
      this.load = true
      this.AdminService.getAdmins().subscribe(
        (res: any) => {
          this.load = false
          this.error = false
          console.log(res);

          const rawAdmins = (res?.data ?? []) as any[];
          this.data = rawAdmins.map((a) => {
            // normalize permission
            let perm: string[] = [];
            const p = (a as any).permission;
            if (Array.isArray(p)) {
              perm = p.filter(Boolean).map(String);
            } else if (typeof p === 'string' && p.trim()) {
              // try JSON first
              try {
                const parsed = JSON.parse(p);
                if (Array.isArray(parsed)) perm = parsed.filter(Boolean).map(String);
                else perm = p.split(',').map(s => s.trim()).filter(Boolean);
              } catch {
                perm = p.split(',').map(s => s.trim()).filter(Boolean);
              }
            }

            // normalize menu ids from relations
            const rel = (a as any).menu_permissions;
            const relIds: number[] = Array.isArray(rel)
              ? rel.map((x: any) => Number(x?.menu_id)).filter((n: any) => Number.isFinite(n))
              : [];

            const fallbackIds: number[] = Array.isArray((a as any).menu_ids)
              ? (a as any).menu_ids.map((n: any) => Number(n)).filter((n: any) => Number.isFinite(n))
              : [];

            const menu_ids = relIds.length ? relIds : fallbackIds;

            return {
              ...a,
              permission: perm,
              menu_ids,
            };
          });
        },
        (error: any) => {
          this.load = false
          this.error = true

        }
      )
    }

    getMenu(){
    this.load = true
    this.MenuService.getMenu().subscribe(
      (res: any) => {
        console.log(res)
        this.load = false
        this.allMenus = res.data;

        // Build flat menu options for permissions modal (id + title)
        this.menuOptions = this.flattenMenus(this.allMenus);

        console.log('all menu: ',this.allMenus)
        // this.applySection();
        // console.log(this.menuItems)
        this.error = false
      },
      (error: any) => {
        this.error = true
        this.load = false
      }
    );
  }

    openModalForAdd() {
      this.form.reset({
        id: null,
        user: '',
        name: '',
        lastname: '',
        password: '',
        repeatPassword: '',
        role: 'admin',
        permissions: {
          menus_view: false,
          menus_create: false,
          menus_edit: false,
          menus_delete: false,
          pages_view: false,
          pages_create: false,
          pages_edit: false,
          pages_delete: false,
          posts: false,
          calendar: false,
          team: false,
          banner: false,
          forms: false,
          faq: false,
          gallery: false,
          files: false,
          live: false,
          comments: false,
          admins: false,
          settings: false,
          logs: false,
          info: false,
        },
        menu_ids: [],
        postCategories: [],
      });
      this.isEditMode = false;
      this.activeModalRef = this.modalService.open(this.editAdminModalRef, { size: 'lg' });
    }

    openEditAdminModal(user: any) {
      this.isEditMode = true;

      const permArr: string[] = Array.isArray(user?.permission) ? user.permission : [];

      // menu_ids might come from relation `menu_permissions`
      const rel = user?.menu_permissions;
      const relIds: number[] = Array.isArray(rel)
        ? rel.map((x: any) => Number(x?.menu_id)).filter((n: any) => Number.isFinite(n))
        : [];
      const menuIds: number[] = relIds.length
        ? relIds
        : (Array.isArray(user?.menu_ids) ? user.menu_ids : []);

      this.form.patchValue({
        id: user.id || null,
        user: user.user || '',
        name: user.name || '',
        lastname: user.lastname || '',
        password: '',
        repeatPassword: '',
        role: user.role || 'manager',
        permissions: {
          menus_view: permArr.includes('menus_view'),
          menus_create: permArr.includes('menus_create'),
          menus_edit: permArr.includes('menus_edit'),
          menus_delete: permArr.includes('menus_delete'),

          pages_view: permArr.includes('pages_view'),
          pages_create: permArr.includes('pages_create'),
          pages_edit: permArr.includes('pages_edit'),
          pages_delete: permArr.includes('pages_delete'),

          posts: permArr.includes('posts'),
          calendar: permArr.includes('calendar'),
          team: permArr.includes('team'),
          banner: permArr.includes('banner'),
          forms: permArr.includes('forms'),
          faq: permArr.includes('faq'),
          gallery: permArr.includes('gallery'),
          files: permArr.includes('files'),
          live: permArr.includes('live'),
          comments: permArr.includes('comments'),
          admins: permArr.includes('admins'),
          settings: permArr.includes('settings'),
          logs: permArr.includes('logs'),
          info: permArr.includes('info'),
        },
        menu_ids: menuIds,
        postCategories: Array.isArray(user.postCategories) ? [...user.postCategories] : [],
      });

      this.activeModalRef = this.modalService.open(this.editAdminModalRef, { size: 'lg' });
    }


  submit() {
    const payload = this.buildPayload();

    this.loading = true;
    this.editBtnLoad = true;

    if (this.isEditMode) {
      this.AdminService.updateAdmin(payload).subscribe(
        () => {
          this.getAdmins();
          this.ToastrService.success('ადმინი წარმატებით დარედაქტირდა');
          this.loading = false;
          this.editBtnLoad = false;
          this.activeModalRef?.close?.();
        },
        () => {
          this.loading = false;
          this.editBtnLoad = false;
          this.ToastrService.error('შეცდომა ადმინის დარედაქტირებისას');
        }
      );
    } else {
      this.AdminService.addAdmin(payload).subscribe(
        () => {
          this.getAdmins();
          this.ToastrService.success('ადმინი წარმატებით დაემატა');
          this.loading = false;
          this.editBtnLoad = false;
          this.activeModalRef?.close?.();
        },
        () => {
          this.loading = false;
          this.editBtnLoad = false;
          this.ToastrService.error('შეცდომა ადმინის დამატებისას');
        }
      );
    }
  }

  cancel() {
    this.activeModalRef?.dismiss?.();
  }

  selectAllPermissions(on: boolean) {
    const grp = this.form.get('permissions') as FormGroup;
    if (!grp) return;
    Object.keys(grp.controls).forEach((k) => grp.get(k)?.setValue(on));
  }

  toggleModule(module: 'menus' | 'pages', on: boolean) {
    const grp = this.form.get('permissions') as FormGroup;
    if (!grp) return;
    ['view', 'create', 'edit', 'delete'].forEach((action) => {
      grp.get(`${module}_${action}`)?.setValue(on);
    });
  }

  private buildPayload() {
    const v = this.form.getRawValue();
    const permsGroup = v.permissions || {};

    // convert checkbox group -> string[] like ['menus_view','pages_edit',...]
    const permission: string[] = Object.keys(permsGroup)
      .filter((k) => permsGroup[k] === true);

    return {
      id: v.id,
      user: v.user,
      name: v.name,
      lastname: v.lastname,
      password: v.password || '',
      repeatPassword: v.repeatPassword || '',
      role: v.role,
      permission,
      menu_ids: Array.isArray(v.menu_ids) ? v.menu_ids : [],
      postCategories: Array.isArray(v.postCategories) ? v.postCategories : [],
    };
  }

    confirmDelete(user: any){
      if(confirm('ნამდვილათ გსურთ წაშალოთ ადმინი: ' + user.name)){
        this.deleteUserId = user.id
        this.AdminService.detete(user.id).subscribe(
          (res: any) => {
            this.getAdmins()
            this.ToastrService.success('ადმინი წაიშალა')
            this.deleteUserId = 0
          },
          (error: any) => {
            this.ToastrService.error('შეცდომა ადმინის წაშლისას')
            this.deleteUserId = 0
          }
        )
      }
    }

  private flattenMenus(allMenus: Record<string, any[]>): Array<{ id: number; title: string }> {
    const out: Array<{ id: number; title: string }> = [];

    const walk = (items: any[]) => {
      for (const it of items || []) {
        const id = Number(it.id);
        const title = String(it.title ?? it.menutitle ?? '');
        if (!Number.isNaN(id) && title) out.push({ id, title });
        if (Array.isArray(it.children) && it.children.length) walk(it.children);
      }
    };

    // res.data is usually grouped by section: { top:[], main:[], hidden:[] ... }
    for (const key of Object.keys(allMenus || {})) {
      const arr = allMenus[key];
      if (Array.isArray(arr)) walk(arr);
    }

    // de-duplicate by id
    const map = new Map<number, string>();
    for (const m of out) map.set(m.id, m.title);
    return Array.from(map.entries()).map(([id, title]) => ({ id, title }));
  }












  getFilteredMenuOptions() {
  const q = (this.menuSearch || '').trim().toLowerCase();

  if (!q) {
    return this.menuOptions || [];
  }

  return (this.menuOptions || []).filter((m: any) =>
    String(m.title || '').toLowerCase().includes(q)
  );
}

trackByMenuId(index: number, item: any) {
  return item.id;
}

isMenuSelected(menuId: number): boolean {
  const ids = this.form.get('menu_ids')?.value || [];
  return ids.map((x: any) => +x).includes(+menuId);
}

toggleMenuSelection(menuId: number, checked: boolean) {
  const control = this.form.get('menu_ids');
  const current = Array.isArray(control?.value) ? [...control!.value] : [];
  const normalized = current.map((x: any) => +x);

  if (checked) {
    if (!normalized.includes(+menuId)) {
      normalized.push(+menuId);
    }
  } else {
    const index = normalized.indexOf(+menuId);
    if (index > -1) {
      normalized.splice(index, 1);
    }
  }

  control?.setValue(normalized);
  control?.markAsDirty();
  control?.markAsTouched();
}

selectAllMenus() {
  const ids = (this.menuOptions || []).map((m: any) => +m.id);
  this.form.get('menu_ids')?.setValue(ids);
  this.form.get('menu_ids')?.markAsDirty();
  this.form.get('menu_ids')?.markAsTouched();
}

clearAllMenus() {
  this.form.get('menu_ids')?.setValue([]);
  this.form.get('menu_ids')?.markAsDirty();
  this.form.get('menu_ids')?.markAsTouched();
}

}